import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function StoreLayout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-black" data-id="element-711" data-mp="1sapsrquktu0h">
      <Navbar data-id="element-712" data-mp="1eaohrikll67a" />
      <main className="flex-1" data-id="element-713" data-mp="1eayb9g4upvhq">
        <Outlet data-id="element-714" data-mp="1ebzvob7rbuc4" />
      </main>
      <Footer data-id="element-715" data-mp="1ecswkvk1bpmc" />
    </div>;
}